import { configureStore } from '@reduxjs/toolkit';

import paginationReducer from '../components/paginationSlice';

export const store = configureStore({
  reducer: {
    pagination: paginationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});